module.exports = (theme) => ({
  ".teaser": {
    maxWidth: theme("screens.xl"),
    marginLeft: "auto",
    marginRight: "auto",
  },
  ".teaser-container": {
    display: "flex",
    flexDirection: "column",
    marginRight: "auto",
    marginLeft: "auto",
    paddingTop: theme("spacing.xl"),
    paddingBottom: theme("spacing.xl"),
    paddingLeft: theme("spacing.lg"),
    paddingRight: theme("spacing.lg"),
  },

  ".teaser-background-theme-grey": { "@apply ds-bg-background-grey": 1 },
  ".teaser-background-theme-blue": { "@apply ds-bg-background-blue": 1 },

  ".teaser-media": {
    paddingLeft: "0",
    paddingRight: "0",
    width: "100%",
  },

  ".teaser-media img": {
    width: "100%",
    margin: "0 auto",
  },

  ".teaser-content": {
    padding: "0",
    paddingTop: "34px",
  },

  ".teaser-heading": {
    fontSize: theme("fontSize.3xl"),
    fontFamily: theme("fontFamily.display"),
    fontWeight: theme("fontWeight.bold"),
    lineHeight: theme("spacing.xl"),
    marginBottom: theme("spacing.xl"),
  },

  ".teaser-heading-h2": { "@apply ds-h2 ds-mb-xl": 1 },

  ".teaser-heading-h3": { "@apply ds-h3 ds-mb-xl": 1 },

  ".teaser-text p": {
    marginBottom: theme("spacing.xl"),
    lineHeight: theme("spacing.xl"),
  },

  ".teaser .link": {
    color: "black",
  },

  ".teaser-round-image img": {
    borderRadius: "50%",
    minHeight: "260px",
    minWidth: "260px",
    objectFit: "cover",
    width: "50%",
  },

  ".teaser-reversed .teaser-content": {
    order: 1,
  },

  ".teaser-small": {
    width: "100%",
  },

  ".teaser-small .teaser-media img": {
    height: "200px",
    width: "200px",
    minHeight: "200px",
    minWidth: "200px",
    objectFit: "cover",
  },

  ".teaser-small .teaser-heading-h2": { "@apply ds-text-3xl ds-leading-lg ds-mb-sm": 1 },

  ".teaser-small .teaser-heading-h3": { "@apply ds-text-2xl ds-leading-base ds-mb-sm": 1 },

  ".teaser-small .teaser-content": {
    paddingTop: theme("spacing.DEFAULT"),
    paddingBottom: theme("spacing.DEFAULT"),
    paddingLeft: "0",
    paddingRight: "0",
  },

  ".teaser-small .teaser-text p": {
    marginBottom: theme("spacing.DEFAULT"),
  },

  [`@media (min-width: ${theme("screens.xs")})`]: {
    ".teaser-round-image img": { minHeight: "315px", minWidth: "315px" },
  },

  [`@media screen and (min-width: ${theme("screens.sm")})`]: {
    ".teaser-media img": {
      width: "50%",
    },
    ".teaser-round-image img": {
      minHeight: "363px",
      minWidth: "363px",
      width: "33%",
    },
    ".teaser-small .teaser-container": {
      flexDirection: "row",
      padding: theme("spacing.2xl"),
    },
    ".teaser-small .teaser-media": {
      width: "auto",
    },
    ".teaser-small .teaser-content": {
      paddingTop: theme("spacing.DEFAULT"),
      paddingBottom: theme("spacing.DEFAULT"),
      paddingLeft: theme("spacing.2xl"),
      paddingRight: theme("spacing.lg"),
    },
    [`.teaser-heading-h2, .teaser-heading-h3`]: { "@apply ds-mb-xl": 1 },
  },

  [`@media (min-width: ${theme("screens.lg")})`]: {
    ".teaser-container": {
      flexDirection: "row",
      justifyContent: "space-between",
      padding: theme("spacing.4xl"),
    },
    ".teaser-media": {
      height: "400px",
      width: "516px",
    },
    ".teaser-media img": {
      height: "100%",
      objectFit: "cover",
      width: "100%",
    },
    ".teaser-content": {
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      order: -1,
      paddingRight: theme("spacing.2xl"),
    },
    [`.teaser-heading-h2, .teaser-heading-h3`]: { "@apply ds-max-w-[456px]": 1 },
    ".teaser-text": {
      maxWidth: "552px",
    },
    ".teaser-round-image img": {
      height: "380px",
      width: "380px",
    },
    ".teaser-reversed .teaser-content": {
      paddingLeft: theme("spacing.2xl"),
      paddingRight: "0",
    },
    ".teaser-small .teaser-content": {
      paddingLeft: "0",
      paddingRight: theme("spacing.2xl"),
    },

    ".teaser-small.teaser-reversed .teaser-content": {
      paddingLeft: theme("spacing.2xl"),
      paddingRight: "0",
    },

    ".teaser-small .teaser-media": {
      height: "200px",
      width: "200px",
    },

    ".teaser-small .teaser-container": {
      padding: theme("spacing.2xl"),
      maxWidth: "720px",
      boxSizing: "border-box",
      margin: "0",
    },
  },

  [`@media (min-width: ${theme("screens.xl")})`]: {
    ".teaser-round-image img": {
      height: "400px",
      width: "400px",
    },
  },
});
